import { render, staticRenderFns } from "./feed-detail.vue?vue&type=template&id=5557bba0&scoped=true&"
import script from "./feed-detail.vue?vue&type=script&lang=js&"
export * from "./feed-detail.vue?vue&type=script&lang=js&"
import style0 from "./feed-detail.vue?vue&type=style&index=0&id=5557bba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5557bba0",
  null
  
)

export default component.exports